export default __webpack_public_path__ + "static/sens-aec4c8c6b7c42305fd0399fd81a37629.png";